/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconStackForward = createReactComponent("outline", "stack-forward", "IconStackForward", [["path", { "d": "M12 5l-8 4l8 4l8 -4l-8 -4", "fill": "currentColor", "key": "svg-0" }], ["path", { "d": "M10 12l-6 3l8 4l8 -4l-6 -3", "key": "svg-1" }]]);

export { IconStackForward as default };
//# sourceMappingURL=IconStackForward.mjs.map
